// extracted by mini-css-extract-plugin
module.exports = {"main":"trade_main__Ucdon","nav":"trade_nav__BidzQ","content":"trade_content__kF2qd"};